<ng-container>
    <div class="mat-dialog-title">
        <div class="pw-dialog-header">
            <div class="pw-dialog-title">Comparison</div>
            <button mat-icon-button class="pw-dialog-close" mat-dialog-close="" aria-label="close button [compare]">
                <svg class="nr-icon-24">
                    <use xlink:href="#pw_close"></use>
                </svg>
            </button>
        </div>
    </div>
    <mat-dialog-content class="compare-content">
        <div class="compare-table">
            <div class="compare-header compare-line">
                <div class="features">Features</div>
                <div class="plus">Plus</div>
                <div class="prem">Premium</div>
            </div>
            <div class="compare-line">
                <div class="features">Human- like AI Plus Voices (500k chars / day) </div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    &nbsp;
                </div>
            </div>
            <div class="compare-line">
                <div class="features">Non-AI Premium Voices</div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
            </div>
            <div class="compare-line">
                <div class="features">Download to MP3 (1 Million chars / month) </div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
            </div>
            <div class="compare-line">
                <div class="features">OCR (scan image to text)</div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
            </div>
            <div class="compare-line">
                <div class="features">AI text filtering</div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
            </div>
            <div class="compare-line">
                <div class="features">Chrome extension</div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
            </div>
            <div class="compare-line">
                <div class="features">iOS & Android mobile app</div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
            </div>
            <div class="compare-line">
                <div class="features">Pronunciation Editor</div>
                <div class="plus">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
                <div class="prem">
                    <svg class="nr-icon-24">
                        <use xlink:href="#pw_done"></use>
                    </svg>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</ng-container>